import refinement from './refinement';
import { typeOf } from '@ember/utils';
import PageviewCondition from 'cio/app-models/conditions/pageview';
import { serializeFilters } from 'cio/utils/conditions/serialize/event';

export default function (obj: PageviewCondition) {
  let { url, anyUrl, filters, filterOperator, inverse } = obj;
  let { times, within } = refinement(obj);

  if (typeOf(url) === 'string') {
    url = (url as string).trim();
  }

  if (anyUrl) {
    url = '*';
  }

  return {
    event: {
      type: 'page',
      name: url,
      filters: serializeFilters(filters, filterOperator),
    },
    times,
    within,
    inverse,
  };
}
